export enum GridEventType
{
    DataCleared = 'DataCleared',
    InitialRowsAdded = 'InitialRowsAdded',
    RowsAdded = 'RowsAdded',
    RowsCleared = 'RowsCleared',
    ColumnsAdded = 'ColumnsAdded',
    RowsAndColumnsAdded = 'RowsAndColumnsAdded',

    RowSelectionChanged = 'RowSelectionChanged',

    ColumnWidthChanged = 'ColumnWidthChanged',

    ColumnsFilterChanged = 'ColumnsFilterChanged',
    IsTransposedChanged = 'IsTransposedChanged'
}

export class GridEvent
{
    public constructor(public readonly type:GridEventType)
    {
    }
}
